const capitalize = string => `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`

const ajaxError = (err, callback = () => {}) => {
    const { data = {}, errors = {}, message = null } = err.response.data;
    if(message) toastr.info(capitalize(message), null, { timeOut: 10000 });
    for (let [key, values] of Object.entries(errors)) {
        values.map((msg, i) => toastr.info(capitalize(msg), { timeOut: 10000 }))
        if(err.isAxiosError) {
            const _el = document.querySelector(`[name="${key}"]`)
            if(_el && !_el.classList.contains('is-invalid')) _el.classList.add('is-invalid')
        }
    }
    callback();
};

const ajaxSuccess = (res, callback = () => {}) => {
    const { message = null } = res.data;
    if(message) toastr.success(capitalize(message), null, { timeOut: 3500 });
    callback();
}

const iconMimeType = (mimeType) => {
    // List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
    const mimeTypesMap = Object.freeze({
        // Media
        'image': 'fa-file-image',
        'audio': 'fa-file-audio',
        'video': 'fa-file-video',
        
        // Archives
        'application/zip': 'fa-file-archive',
        'application/gzip': 'fa-file-archive',
        'application/x-bzip': 'fa-file-archive',
        'application/x-gtar': 'fa-file-archive',
        'application/x-bzip2': 'fa-file-archive',
        'application/x-ace-compressed': 'fa-file-archive',
        'application/x-rar-compressed': 'fa-file-archive',
        
        // Documents
        'text/csv': 'fa-file-csv',
        'text/css': 'fa-file-code',
        'text/html': 'fa-file-code',
        'text/plain': 'fa-file-alt',
        'application/pdf': 'fa-file-pdf',
        'application/json': 'fa-file-code',
        'application/x-font-bdf': 'fa-file',
        'application/x-font-otf': 'fa-file',
        'application/x-latex': 'fa-file-alt',
        'application/msword': 'fa-file-word',
        'application/vnd.ms-word': 'fa-file-word',
        'application/vnd.ms-excel': 'fa-file-excel',
        'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
        'application/vnd.oasis.opendocument.text': 'fa-file-word',
        'application/vnd.oasis.opendocument.text': 'fa-file-alt',
        'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel',
        'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint',
        'application/vnd.openxmlformats-officedocument.spreadsheetml': 'fa-file-excel',
        'application/vnd.openxmlformats-officedocument.wordprocessingml': 'fa-file-word',
        'application/vnd.openxmlformats-officedocument.presentationml': 'fa-file-powerpoint',
    })

    const [iconMime = null, icon = 'fa-file-o'] = Object.entries(mimeTypesMap).find(([key, val]) => mimeType.includes(key)) || []
    return icon
}

window.iconMimeType = iconMimeType

const bytesToHuman = (bytes) => {
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

    let i = 0
    for (i; bytes > 1024; i++) bytes /= 1024;

    return `${Math.round((bytes + Number.EPSILON) * 100) / 100} ${units[i]}`;
}

export {
    ajaxError,
    capitalize,
    ajaxSuccess,
    iconMimeType,
    bytesToHuman
}